// ChartDonut.jsx
//
// Компактна кільцева діаграма з підсумком у центрі та легендою знизу —
// спільний візуальний стиль для розподілів (стать/пільга/труднощі), що
// використовується і в зведеному графіку по місту (ChildrenTab.jsx), і в
// деталізації одного садочка (ChildrenKindergartenDetail.jsx).
import React from 'react';
import { Pie } from 'react-chartjs-2';
import { externalTooltipHandler } from './utils/externalTooltip';
import './chartConfig';

const miniPieOptions = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false, external: externalTooltipHandler, callbacks: { label: (ctx) => `${ctx.label}: ${ctx.raw.toLocaleString()}` } },
  },
  cutout: '55%',
};

const ChartDonut = ({ title, total, data, legend, size = 130 }) => (
  <div style={{ flex: '1 1 200px', minWidth: 200, textAlign: 'center' }}>
    <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#374151', marginBottom: 8 }}>{title}</div>
    {total > 0 ? (
      <>
        <div style={{ position: 'relative', width: size, height: size, margin: '0 auto' }}>
          <div style={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            width: size * 0.46, height: size * 0.46, background: '#fff', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 1px 4px rgba(0,0,0,0.12)', zIndex: 1,
          }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 700, color: '#2c3e50' }}>{total.toLocaleString()}</span>
          </div>
          <Pie data={data} options={miniPieOptions} />
        </div>
        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
          {legend.map(({ label, value, color }) => (
            <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '0.76rem', color: '#4b5563' }}>
              <span style={{ width: 10, height: 10, borderRadius: 2, background: color, flexShrink: 0 }} />
              <span>{label}: {value.toLocaleString()}</span>
            </div>
          ))}
        </div>
      </>
    ) : (
      <div style={{ fontSize: '0.8rem', color: '#9ca3af', padding: '30px 0' }}>Немає даних</div>
    )}
  </div>
);

export default ChartDonut;